import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { UiModule } from "../ui/ui.module";
import { SyllabusEditButtonComponent } from "./syllabus-edit-button/syllabus-edit-button.component";
import { SyllabusDetailComponent } from './syllabus-detail/syllabus-detail.component';
import { SyllabusEditComponent } from './syllabus-edit/syllabus-edit.component';
import { SyllabusCurriculumComponent } from './syllabus-curriculum/syllabus-curriculum.component';
import { SyllabusCurriculumEditComponent } from './syllabus-curriculum-edit/syllabus-curriculum-edit.component';
import { SyllabusCurriculumNumberingListComponent } from './syllabus-numbering-list/syllabus-curriculum-numbering-list.component';
import { SyllabusCurriculumNumberingListEditComponent } from './syllabus-numbering-list-edit/syllabus-curriculum-numbering-list-edit.component';
import { SyllabusPhotoChoiceButtonComponent } from './syllabus-photo-choice-button/syllabus-photo-choice-button.component';
import { SyllabusAddButtonComponent } from './syllabus-add-button/syllabus-add-button.component';
import { SyllabusRecommendersComponent } from './syllabus-recommenders/syllabus-recommenders.component';
import { SyllabusRecommendersEditComponent } from './syllabus-recommenders-edit/syllabus-recommenders-edit.component';
import { SyllabusImageService } from "./shared/syllabus-image.service";


@NgModule({
  imports: [
    SharedModule,
    UiModule
  ],
  declarations: [
    SyllabusEditButtonComponent,
    SyllabusDetailComponent,
    SyllabusEditComponent,
    SyllabusCurriculumComponent,
    SyllabusCurriculumEditComponent,
    SyllabusCurriculumNumberingListComponent,
    SyllabusCurriculumNumberingListEditComponent,
    SyllabusPhotoChoiceButtonComponent,
    SyllabusAddButtonComponent,
    SyllabusRecommendersComponent,
    SyllabusRecommendersEditComponent
  ],
  exports: [
    SyllabusDetailComponent
  ],
  providers: [
    SyllabusImageService
  ]
})
export class SyllabusesModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabuses.module.ts